<div class="name" data-test="department-list-item">{{ name() }}</div>
@if (isOccupationEmpty()) {
	<div class="residents-summary">
		{{ "pageFilter.department.occupation.empty" | translate }}
	</div>
}
